<template>

    <m-edit1/>

    <m-section v-bind='{...{},...{}}' :style='"padding:64px 0px;\nheight:65vh;"' class="container-fluid" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="container-custom mx-auto py-3" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="rom mx-auto justify-content-center text-center" >
                <template #default>   <m-h2 v-bind='{...{},...{}}' :style='"font-size: clamp(22px, 3vw, 34px);\ncolor:black;\nfont-weight:bold;\n\n"' class=" d-inline-block border-primary-buttom text-dark" >
                <template #default>ثبت درخواست   </template>
                </m-h2><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6 col-md-6 px-2 mb-2 mx-auto" >
                <template #default>   <m-p v-bind='{...{},...{}}' :style='""' class="text-caption" >
                <template #default>با تشکر از شما   </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="text-caption" >
                <template #default>درخواست شما ثبت گردید، همکاران ما در اصرع وقت با  شما تماس خواهند گرفت   </template>
                </m-p><m-a v-bind='{...{"href":"https:\/\/medicalmobile.ir\/","target":"_self"},...{}}' :style='""' class="btn btn-primary" >
                <template #default>بازگشت به صفحه اصلی   </template>
                </m-a></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-section>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSection from '@moeinmdn/miw-alpha-components/src/package/Tags/Section'; import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH2 from '@moeinmdn/miw-alpha-components/src/package/Tags/H2'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A';

export default {
    name: 'HomeView',
    components: {mEdit1, mSection,mDiv,mH2,mP,mA },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
